import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { TextareaInlineField } from '../../../../Textarea'
import {
  DOC_FLOW_FORM_FIELD_FINAL_DOCUMENT_TITLE,
  DOC_FLOW_FORM_FINAL_NAME_FIELD_MAX_LENGTH,
} from '../../../DocFlow.constants'
import { DocFlowVariableField } from '../../../DocFlowVariableField'

function DocFlowFormFinalDocumentTitleFields() {
  const { t } = useTranslation()

  const inputRef = useRef(null)

  const { isMobileScreenSize } = useScreen()

  return (
    <>
      <DocFlowVariableField
        controlProps={{ borderless: !isMobileScreenSize }}
        fieldComponentProps={{
          label: `${t('DocumentStapling.FormVariableFieldLabelKey')}:`,
          shouldAdaptToMobileScreen: true,
        }}
        inputRef={inputRef}
        titleFieldName={DOC_FLOW_FORM_FIELD_FINAL_DOCUMENT_TITLE}
      />
      <FormikField
        clearable
        hasCounter
        Component={TextareaInlineField}
        borderless={!isMobileScreenSize}
        elementRef={inputRef}
        fieldComponentProps={{
          info: t('DocumentStapling.FormFinalDocumentNameFieldInfoKey'),
          label: `${t('DocumentStapling.FormFinalDocumentNameFieldLabelKey')}:`,
          required: true,
          shouldAdaptToMobileScreen: true,
        }}
        getErrorProps={getFormikFormFieldErrorProps}
        maxLength={DOC_FLOW_FORM_FINAL_NAME_FIELD_MAX_LENGTH}
        name={DOC_FLOW_FORM_FIELD_FINAL_DOCUMENT_TITLE}
        placeholder={t(
          'DocumentStapling.FormFinalDocumentNameFieldPlaceholderKey'
        )}
      />
    </>
  )
}

export default DocFlowFormFinalDocumentTitleFields
